const background = '#ffffff'
const border = '#DEDEDE'
const mainColor = '#7131ff'
const mainLightColor = '#f1ebff'
const connectedColor = mainColor
const disabled = '#5D6D74'
const errorColor = '#FF3E3E'
const errorBGColor = '#FFDEDE'
const successColor = '#53b744'
const successBGColor = '#f5fff4'
const fancyColor = '#FF3E3E'
const fontColor = '#001428'
const headerHeight = '52px'
const lg = '24px'
const marginButtonImg = '12px'
const md = '16px'
const nm = '14px'
const primary = '#001428'
const secondary = '#7131ff'
const secondaryTextOrSvg = '#B2B5B2'
const secondaryBackground = '#f0efee'
const sm = '8px'
const warningColor = '#f59400'
const warningColorLight = '#FFFCF6'
const xl = '32px'
const xs = '4px'
const xxl = '40px'

module.exports = {
  background,
  boldFont: 700,
  mainColor: mainColor,
  mainLightColor: mainLightColor,
  bolderFont: 500,
  border,
  buttonLargeFontSize: '16px',
  connected: connectedColor,
  disabled,
  error: errorColor,
  errorBG: errorBGColor,
  successColor: successColor,
  successBGColor: successBGColor,
  extraBoldFont: 800,
  extraLargeFontSize: '20px',
  extraSmallFontSize: '11px',
  fancy: fancyColor,
  fontColor,
  greyColor: '#c3c3c3',
  fontSizeHeadingLg: 32,
  fontSizeHeadingMd: 20,
  fontSizeHeadingSm: 16,
  fontSizeHeadingXs: 13,
  headerHeight,
  largeFontSize: '16px',
  lg,
  borderRadius: '8px',
  lightFont: 300,
  mainFontFamily: '"Libre Franklin", sans-serif',
  marginButtonImg,
  md,
  nm,
  mediumFontSize: '14px',
  primary: mainColor,
  regularFont: 400,
  screenLg: 1200,
  screenMd: 992,
  screenMdMax: 1199,
  screenSm: 768,
  screenSmMax: 991,
  screenXs: 480,
  screenXsMax: 767,
  secondary,
  secondaryFontFamily: '"Libre Franklin", monospace',
  secondaryText: secondaryTextOrSvg,
  secondaryBackground,
  sm,
  smallFontSize: '12px',
  warning: warningColor,
  warningLight: warningColorLight,
  xl,
  xs,
  xxl,
  xxlFontSize: '32px',
}
